import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  addRemoveToFavouriteAction,
  getAllClientsAction,
  getAssignedClientsToUserAction,
  getIndividualClientsAction,
  resetAssignedClientsToUserList,
  resetAuthError,
  resetAuthMessage,
  resetAuthSuccess,
  resetFavouriteClientToUserList,
  resetIndividualClientList,
  resetSession,
  resetUnFavouriteClientToUserList,
} from "../../redux/auth";
import { RootState } from "../../redux/rootReducers";
import {
  CommonHeader,
  ErrorSuccessModal,
  Sort,
  CardLoader,
  NosearchResult,
} from "../../components/commons";
import { ClientCard } from "../../components/Clients";
import {
  AssignedClientsToUserType,
  ClientType,
  LoginResponseType,
} from "../../redux/auth/authTypes";
import {
  AddRemoveFromFavouritePayloadType,
  GetAssignedClientsToUserPayloadType,
  getIndividualClientsPayload,
} from "../../commonTypes/authTypes";
import "./Home.scss";
import { SearchIcon } from "../../components/Icon";
import useDebounce from "../../customHooks/useDebounce";
import ScrollToTop from "../../components/commons/ScrollToTop";
import toast, { Toaster } from "react-hot-toast";

type CurrencyDetailsType={
  currencySign: string | undefined,
  currencyName: string | undefined,
  currencyShortForm: string | undefined,
}
type AppProps = {
  dispatchGetAllClientsAction: (data: any) => void;
  dispatchGetIndividualClientListAction: (
    data: getIndividualClientsPayload
  ) => void;
  dispatchResetAuthMessage: () => void;
  fetching: boolean;
  error: string | null;
  loginData: LoginResponseType;
  token: string | null;
  statusCode: number | null;
  success: number | null;
  message: string | null;
  totalUnfavouriteClient:number;
  individualClientList: [] | ClientType[];
  assignedClientsToUserList: [] | AssignedClientsToUserType[];
  favouriteClientsToUserList: [] | AssignedClientsToUserType[];
  unFavouriteClieintsToUserList: [] | AssignedClientsToUserType[];
  history: any;
  dispatchResetAuthError: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetSession: () => void;
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => void;
  dispatchAddRemoveFromFavourite: (
    data: AddRemoveFromFavouritePayloadType
  ) => void;
  dispatchResetFavouriteClientToUserList: () => void;
  dispatchResetAssignedClientsToUserList: () => void;
  dispatchResetIndivididualClientList: () => void;
  dispatchResetUnFavouriteClientToUserList: () => void;
};

const Home = ({
  dispatchGetAllClientsAction,
  dispatchGetIndividualClientListAction,
  dispatchGetAssignedClientsToUserAction,
  dispatchResetFavouriteClientToUserList,
  dispatchResetAssignedClientsToUserList,
  dispatchResetUnFavouriteClientToUserList,
  dispatchResetIndivididualClientList,
  dispatchResetSession,
  dispatchResetAuthError,
  dispatchResetAuthMessage,
  dispatchResetAuthSuccess,
  individualClientList,
  assignedClientsToUserList,
  favouriteClientsToUserList,
  unFavouriteClieintsToUserList,
  totalUnfavouriteClient,
  dispatchAddRemoveFromFavourite,
  fetching,
  error,
  success,
  statusCode,
  loginData,
  message,
  token,
  history,
}: AppProps) => {
  const { is_client } = loginData;
  const [data, setData] = useState<any>([]);
  const [sortByName, setSortByName] = useState({ name: "", value: "" });
  const [sortByCc, setSortByCc] = useState({
    name: "Client code - Ascending",
    value: "asc",
  });
  const [text, setText] = useState("");
  const [favouriteData, setFavouriteData] = useState<
    [] | AssignedClientsToUserType[]
  >([]);
  const [assignedClientToUserData, setAssignedClientToUserData] = useState<
    [] | AssignedClientsToUserType[]
  >([]);
  const prevData = useRef("");
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);

  useEffect(() => {
    setData([
      { name: " Name - A to Z Order", value: "asc" },
      { name: "Name - Z to A Order", value: "desc" },
      { name: "Client code - Ascending", value: "asc" },
      { name: "Client code - Descending", value: "desc" },
    ]);
    dispatchResetFavouriteClientToUserList();
    dispatchResetAssignedClientsToUserList();
    dispatchResetIndivididualClientList();
    dispatchResetUnFavouriteClientToUserList();
    dispatchResetAuthError()
    dispatchResetAuthMessage()
    dispatchResetAuthSuccess()
  }, []);


  useEffect(() => {
    localStorage.removeItem("client_code");
    setOffset(0)
    if (token) {
      let params = {
        token,
        client_code: sortByCc?.value,
        name: sortByName?.value,
        srch_value: text,
        limit,
        offset:0,
      };
      dispatchGetAssignedClientsToUserAction(params);
      dispatchResetAuthError();
    }
    // dispatchGetAllClientsAction({ token });
  }, [sortByName, sortByCc]);

  useEffect(() => {
    if (favouriteClientsToUserList?.length > 0) {
      setFavouriteData([...favouriteClientsToUserList]);
    }
  }, [favouriteClientsToUserList]);

  useEffect(() => {
    if (unFavouriteClieintsToUserList?.length === 0) {
      setAssignedClientToUserData([...unFavouriteClieintsToUserList]);
    }
    if (offset > 0) {
      setAssignedClientToUserData((prv: any) => [...prv, ...unFavouriteClieintsToUserList]);
    } else {
      setAssignedClientToUserData(unFavouriteClieintsToUserList);
    }
  }, [unFavouriteClieintsToUserList]);

  useEffect(() => {
    if (token) {
      let params = {
        token,
        client_code: sortByCc?.value,
        name: sortByName?.value,
        srch_value: text,
        limit,
        offset,
      };
      if (totalUnfavouriteClient) {
        if (offset < totalUnfavouriteClient) {
          dispatchGetAssignedClientsToUserAction(params);
        }
      } else {
        dispatchGetAssignedClientsToUserAction(params);

      }
    }
  }, [offset]);
  
  useEffect(() => {

    if (message == "client favourite list has been updated successfully!") {
      window.scroll(0,0)
      dispatchResetAuthMessage();
      setOffset(0)
      if (token) {
        let params = {
          token,
          client_code: sortByCc?.value,
          name: sortByName?.value,
          srch_value: text,
          limit,
          offset:0,
        };
        dispatchGetAssignedClientsToUserAction(params);
      }
    }
  }, [message]);
  const renderFavouriteList = () => {
    let finalFavouriteList = favouriteData?.map((client: ClientType) => {
      return (
        <div className="col-md-4 mb-2">
          <ClientCard
            key={client.client_code}
            clientData={client}
            redirectToclientDashboard={redirectToclientDashboard}
            type="favourite"
            handleFavorite={handleFavorite}
            isClient={is_client}
          />
        </div>
      );
    });
    return <div className="row">{finalFavouriteList}</div>;
  };

  const fetchNewData = () => {
    dispatchResetFavouriteClientToUserList();
    dispatchResetAssignedClientsToUserList();
    dispatchResetIndivididualClientList();
    dispatchResetUnFavouriteClientToUserList();
    /* if (token && is_client === 1) {
        let params = {
          token,
          client_code: sortByCc?.value,
          name: sortByName?.value,
          srch_value: text,
        };
        dispatchGetIndividualClientListAction(params);
        dispatchResetAuthError();
      } else  */
    if (token) {
      setOffset(0)
      let params = {
        token,
        client_code: sortByCc?.value,
        name: sortByName?.value,
        srch_value: text,
        limit,
        offset:0,
      };
      dispatchGetAssignedClientsToUserAction(params);
      dispatchResetAuthError();
    }
  };

  const renderClientIndividualList = () => {
    let finalClientList = assignedClientToUserData?.map(
      (client: ClientType) => {
        return (
          <div className="col-md-4 mb-2">
            <ClientCard
              key={client.client_code}
              clientData={client}
              redirectToclientDashboard={redirectToclientDashboard}
              handleFavorite={handleFavorite}
              isClient={is_client}
            />
          </div>
        );
      }
    );

    return <div className="row">{finalClientList}</div>;
  };

  const redirectToclientDashboard = (
    clientCode: number | string | undefined,
    client_name: string | undefined,
    currencyDetails: CurrencyDetailsType,
  ) => {
    history.push({
      pathname: `/client-dashboard/${clientCode}`,
      state: { client_code: clientCode, company_name: client_name,currencyDetails},
    });
  };

  const handleSort = (data: any) => {
    if (
      data?.name === "Client code - Ascending" ||
      data?.name === "Client code - Descending"
    ) {
      setSortByCc(data);
      setSortByName({ name: "", value: "" });
    } else {
      setSortByName(data);
      setSortByCc({ name: "", value: "" });
    }
  };

  const handleSearch = (e: any) => {
    prevData.current = text;
    setText(e.target.value);
  };

  useDebounce(
    () => {
      if (prevData.current.length > 0 || text?.length > 0) {
        fetchNewData();
      }
    },
    500,
    [text]
  );

  const handleFavorite = (clientCode: string, type: string) => {
    dispatchResetAuthMessage();
    setOffset(0);
    let finalPayload = {
      token,
      client_code: clientCode,
      is_fav_client: type === "favourite" ? 0 : 1,
    };

    dispatchAddRemoveFromFavourite(finalPayload);
  };

const onScroll = () => {
  if (!fetching) {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    if (
      offset < totalUnfavouriteClient &&
      !fetching &&
      Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
    ) {
      if (unFavouriteClieintsToUserList?.length > 19) {
        if (!fetching && offset < totalUnfavouriteClient) {
          setOffset(offset + limit);

        }
      }
    }
  }
};

useEffect(() => {
  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
}, [unFavouriteClieintsToUserList]);

  const handleErrorModal = () => {
    if (!!error && success === 0 && statusCode !== 401) {
      dispatchResetAuthError()
      dispatchResetAuthMessage()
      dispatchResetAuthSuccess()
      showToast("You can mark up to 20 favorite clients only!");
      return false;
    }
  
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired! Please login again."
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      }
    }

    return false;
  };
  const showToast = (error:any) => {
    toast.error(error, {
      duration: 2000
    });
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <CommonHeader title="Clients List" />
      </div>

      <div className="d-flex col-md-8  position-relative mt-2">
        <span style={{ position: "absolute", top: "8px", left: "30px" }}>
          <SearchIcon />
        </span>
        <input
          className="form-control"
          type="text"
          placeholder="Search client, client code, location..."
          onChange={(e: any) => handleSearch(e)}
          style={{ paddingLeft: "35px" }}
        />
        <div className="ml-3">
          <Sort
            data={data}
            handleChange={handleSort}
            selectedData={sortByName?.value ? sortByName : sortByCc}
          />
        </div>
      </div>
      {fetching  && offset == 0? (
        <CardLoader times={12} />
      ) : text?.length > 0 &&
        favouriteClientsToUserList?.length === 0 &&
        individualClientList?.length === 0 &&
        unFavouriteClieintsToUserList?.length === 0 ? (
        <NosearchResult />
      ) : (
        <>
          {favouriteClientsToUserList?.length > 0 && (
            <>
              <div className="col-md-12 title">FAVOURITE CLIENTS</div>
              <div className="col-md-12">{renderFavouriteList()}</div>
            </>
          )}

          {(individualClientList?.length > 0 ||
            unFavouriteClieintsToUserList?.length > 0) && (
            <>
              <div className="col-md-12 title">ALL CLIENTS</div>
              <div className="col-md-12">{renderClientIndividualList()}</div>
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
            </>
          )}
        </>
      )}
      <Toaster />

      {handleErrorModal()}
      {/* {fetching && 
            (<CardLoader times={12}/> )
            } */}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.auth.fetching,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
  success: state.auth.success,
  message: state.auth.message,
  loginData: state.auth.loginData,
  individualClientList: state.auth.individualClientList,
  assignedClientsToUserList: state.auth.assignedClientsToUserList,
  favouriteClientsToUserList: state.auth.favouriteClientsData,
  unFavouriteClieintsToUserList: state.auth.unFavouriteClientsData,
  totalUnfavouriteClient:state.auth.totalUnfavouriteClient
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllClientsAction: (data: any) =>
    dispatch(getAllClientsAction(data)),
  dispatchGetIndividualClientListAction: (data: getIndividualClientsPayload) =>
    dispatch(getIndividualClientsAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetAuthMessage: () => dispatch(resetAuthMessage()),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFavouriteClientToUserList: () =>
    dispatch(resetFavouriteClientToUserList()),
  dispatchResetUnFavouriteClientToUserList: () =>
    dispatch(resetUnFavouriteClientToUserList()),
  dispatchResetAssignedClientsToUserList: () =>
    dispatch(resetAssignedClientsToUserList()),
  dispatchResetIndivididualClientList: () =>
    dispatch(resetIndividualClientList()),
  dispatchAddRemoveFromFavourite: (data: AddRemoveFromFavouritePayloadType) =>
    dispatch(addRemoveToFavouriteAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
